import ContactForm from '../../components/ContactForm/ContactForm'
import SEO from '../../seo/SEO'
import { generateOrganizationSchema } from '../../seo/structuredData'
import './Contacto.css'

const Contacto = () => {
  const structuredData = generateOrganizationSchema()

  return (
    <>
      <SEO 
        title="Contacto"
        description="Contacta con el Estudio Contable Vanesa Mondejar. WhatsApp +54 9 11 6620-1346, email, formulario de contacto. Respuesta inmediata y consulta personalizada sin compromiso. Estudio contable profesional."
        canonical="https://vanesamondejar.com/contacto"
        structuredData={structuredData}
        keywords="contacto estudio contable, vanesa mondejar contacto, estudio contable vanesa mondejar contacto, whatsapp contador, consulta contable"
      />
      
      <main className="contacto">
        <section className="contacto-hero">
          <div className="container">
            <div className="contacto-hero__content">
              <h1 className="contacto-hero__title">Contactanos</h1>
              <p className="contacto-hero__subtitle">
                Estamos aquí para ayudarte. Elegí la forma de contacto que prefieras y nos pondremos en contacto contigo a la brevedad.
              </p>
            </div>
          </div>
        </section>

        <ContactForm />

        <section className="contacto-map">
          <div className="container">
            <div className="contacto-map__content">
              <h2 className="contacto-map__title">Nuestra Ubicación</h2>
              <p className="contacto-map__subtitle">
                Visitanos en nuestras oficinas para una consulta presencial
              </p>
              
              <div className="contacto-map__container">
                <div className="contacto-map__embed-wrapper">
                  <iframe
                    title="Ubicación Estudio Contable Vanesa Mondejar - Pedernera 89 oficina A Lomas de Zamora"
                    src="https://www.google.com/maps?q=-34.75766813670366,-58.39609184693898&z=17&output=embed"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="contacto-map__iframe"
                  />
                </div>
              </div>
              
              <div className="contacto-map__info">
                <div className="contacto-map__info-item">
                  <h4>📍 Dirección</h4>
                  <p>Pedernera 89 oficina A Lomas de Zamora</p>
                </div>
                <div className="contacto-map__info-item">
                  <h4>🕒 Horarios de Atención</h4>
                  <p>Lunes a Viernes: 8:00 - 17:00</p>
                  <p>Cerrado sábados y domingos</p>
                </div>
                <div className="contacto-map__info-item">
                  <h4>📞 Teléfono</h4>
                  <p>+54 9 11 6620-1346</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="contacto-cta">
          <div className="container">
            <div className="contacto-cta__content">
              <h2 className="contacto-cta__title">¿Necesitas una consulta urgente?</h2>
              <p className="contacto-cta__subtitle">
                Para consultas inmediatas, contactanos por WhatsApp y te responderemos al instante.
              </p>
              <div className="contacto-cta__actions">
                <a 
                  href="https://wa.me/5491166201346" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="contacto-cta__button contacto-cta__button--whatsapp"
                >
                  📱 WhatsApp Inmediato
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export default Contacto
